exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.location-add-card{position:relative;display:flex;justify-content:center;background-color:#222;height:100px;width:246px}.location-add-card .add-location-box{margin-top:10px;border:1px solid #8b8b8b;width:80%;height:36px;left:23px;top:10px}.location-add-card .add-location-box .location-input{font-family:Open Sans,sans-serif;font-weight:700;font-size:13px;color:#fff;letter-spacing:0;line-height:36px;width:160px;border:none;outline:none;text-indent:5px;background-color:transparent}.location-add-card .add-button{position:absolute;left:23px;top:56px;background-color:#4bb543;border-radius:3px;width:60px;height:22px;text-align:center;cursor:pointer}.location-add-card .add-button .add-text{font-family:Open Sans,sans-serif;font-weight:400;font-size:12px;color:#fff;letter-spacing:1px;line-height:20px}.location-add-card .cancel-button{position:absolute;left:95px;top:60px;width:18px;height:18px;background-image:url(" + require("../../../../assets/images/cancel-icon-gray.svg") + ");background-repeat:no-repeat;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/PORNav/LocationAddCard/LocationAddCard.scss
// module id = 1765
// module chunks = 0